import axios from 'axios';
import constants from './constants'
import store from '@/store'
import router from '@/router'
import { RouteNames } from '@/utils/constants/navigationConstants'

var pendingRefreshRequest = false;
const instance = axios.create({
    baseURL: constants.apiUrl,
});

instance.interceptors.request.use(async function (config) {
    let lastRefresh = -(-store.state.user.lastRefresh);
    let refreshPeriod = -(-store.state.user.refreshPeriod);

    if (!pendingRefreshRequest && lastRefresh && refreshPeriod
        && lastRefresh + refreshPeriod < (+new Date()) / 1000
        && !config.url.endsWith('user/refresh-token')) {
        pendingRefreshRequest = true;
        await _makeRequest({ url: 'user/refresh-token', method: 'post' });
        store.commit("updateLastRefresh");
        pendingRefreshRequest = false;
    }

    return config;
});

export default {
    name: 'api',
    async get(path, withCredentials = true) {
        return await _makeRequest({ url: path, withCredentials: withCredentials });
    },
    async post(path, data, withCredentials = true) {
        return await _makeRequest({ url: path, method: 'post', data: data, withCredentials: withCredentials })
    },
    async put(path, data, withCredentials = true) {
        return await _makeRequest({ url: path, method: 'put', data: data, withCredentials: withCredentials })
    }
}

async function _makeRequest(config) {
    config.validateStatus = () => true;
    store.commit("requestStarts", config.url);

    return await instance.request(config)
        .then(async function (response) {
            setTimeout(function () {
                store.commit("requestEnds", config.url);
            }, 50);

            if (response.status === 200) {
                return response.data;
            } else if (response.status === 400) {
                let message;
                if (response.data.errors) {
                    var keys = Object.keys(response.data.errors);
                    if (keys.length) {
                        message = response.data.errors[keys[0]][0];
                    }
                } else {
                    message = response.data
                }

                handleException(message);
            } else if (response.status === 401) {
                await store.dispatch("initUser");
                router.push({ path: '/' });
                throw new Error("Not Authorized");
            } else if (response.status === 403) {
                await store.dispatch("initUser");
                router.push({ name: RouteNames.Forbidden });
                throw new Error("Forbidden");
            } else if (response.status === 404) {
                await store.dispatch("initUser");
                router.push({ name: RouteNames.NotFound });
                throw new Error("Not Found");
            } else if (response.status === 503) {
                handleException(response.statusText)
            }
            else {
                handleException(response.data || "Something went wrong!");
            }
        })
        .catch(function (error) {
            store.commit("requestEnds", config.url);
            throw error;
        })
        .then(function (data) {
            store.commit("requestEnds", config.url);
            return data;
        });
}

function handleException(message) {
    store.commit("addError", message);
    throw new Error(message);
}